module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-base', {
    on: {
      "showErrorModal": function($event) {
        _vm.$emit('showErrorModal', $event)
      },
      "showLoginModal": function($event) {
        _vm.$emit('showLoginModal', $event)
      }
    },
    scopedSlots: _vm._u([
      ["default", function(prop) {
        return [_c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoTitle",
            "co-3": ""
          }
        }, [_vm._v("撮影会名・タイトル"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_name))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoTeacher"
          }
        }, [_vm._v("講師名（活動名）"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.lecturer_name) + " 先生")])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "Photo-date-input"
          }
        }, [_vm._v("開催日"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "Photo-date-public-input"
          }
        }, [_vm._v("開催日(一覧表示用)"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), (prop.item.event_date_public) ? _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date_public))]) : _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date_public_multi))]), _vm._v(" "), (!prop.item.event_date_public) ? _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v("開催日の23:59まで掲載されます。")]) : _vm._e()]), _vm._v(" "), (prop.item.event_date_public) ? _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "Photo-dateEnd-input"
          }
        }, [_vm._v("掲載終了日"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.endDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('p', {
          attrs: {
            "for": "PhotoPlace"
          }
        }, [_vm._v("開催場所・住所"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.fullAddress))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoP_name"
          }
        }, [_vm._v("会場名")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.venue.venue_name))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoTel"
          }
        }, [_vm._v("問い合わせ先電話番号")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.inquiry.tel))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoMail"
          }
        }, [_vm._v("問い合わせ先メールアドレス"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.inquiry.email))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoURL"
          }
        }, [_vm._v("会場ホームページ（アクセス方法）")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.venue.homepage))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoBlog"
          }
        }, [_vm._v("講師ホームページ・ブログ記事URL")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.lecturer_url))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoDes"
          }
        }, [_vm._v("撮影会詳細"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.description))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoDes"
          }
        }, [_vm._v("参加費"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('div', {
          staticClass: "input-group"
        }, [_c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.fee))])])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "AppURL"
          }
        }, [_vm._v("お申し込みURL")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.entry_url))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoParking"
          }
        }, [_vm._v("駐車場有無")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.parking))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "LineAt"
          }
        }, [_vm._v("LINE@")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.line_at))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoInputFile"
          }
        }, [_vm._v("撮影会画像アップロード")]), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, _vm._l((prop.item.images.filter(function (i) { return i !== ''; })), function(f) {
          return _c('image-item', {
            key: f,
            attrs: {
              "image": f
            }
          })
        }))]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "PhotoPublish"
          }
        }, [_vm._v("公開設定"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.published))])])]
      }]
    ])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-372d7b90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/confirm/PhotoConfirm.vue
// module id = 326
// module chunks = 1